import Vue from 'vue';
import {
  DatePicker,
  Button,
  Dialog,
  Switch,
  Loading,
  RadioGroup,
  RadioButton,
  Radio,
  Select,
  Option,
  Message,
  MessageBox,
  Pagination,
  Tag,
  Collapse,
  CollapseItem
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';

Select.computed.readonly = function () {
  // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));

  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};

locale.use(lang);

Vue.use(Loading.directive);

Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(Pagination);
Vue.use(Tag);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
